import { ConversationProvider } from "@my-helpers/common";
import { useParams } from "react-router-dom";
import Layout from "../layout";
import { ConversationView } from "./conversation";
import { ConversationsView } from "./conversations";


const Conversations = () => {
    const { id } = useParams<{ id: string }>();
	return (
		<Layout>
			<ConversationProvider conversationId={id}>
                {
                    id ? <ConversationView /> : <ConversationsView />
                }
			</ConversationProvider>
		</Layout>
	);
};

export default Conversations;